import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPrinter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"printer, print"} maskId="square-filled-radius-0-stroke-1-IconPrinter"><path fillRule="evenodd" clipRule="evenodd" d="M18 2H6V6H2V18H6V22H18V18H22V6H18V2ZM17 6V3H7V6H17ZM17 14H7V21H17V14ZM6 10H10V11H6V10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPrinter;
